import EbidtaRangeFilter from './EbidtaRangeFilter.component';

export default EbidtaRangeFilter;